/**
 * Hosts that must not be treated as Unternehmenswebsites for Twin-Bootstrap.
 * Verhindert u. a. versehentlich eingefügte ChatGPT-/Google-Links.
 */

const BLOCKED_WEBSITE_HOST_SUFFIXES = [
  "chatgpt.com",
  "chat.openai.com",
  "openai.com",
  "claude.ai",
  "anthropic.com",
  "gemini.google.com",
  "bard.google.com",
  "copilot.microsoft.com",
  "bing.com",
  "google.com",
  "gmail.com",
  "facebook.com",
  "instagram.com",
  "twitter.com",
  "x.com",
  "linkedin.com",
  "youtube.com",
  "localhost",
] as const;

export function hostnameFromWebsiteInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed.includes("://") ? trimmed : `https://${trimmed}`);
    return url.hostname.replace(/^www\./i, "").toLowerCase();
  } catch {
    return null;
  }
}

export function isBlockedCompanyWebsite(raw: string): boolean {
  const host = hostnameFromWebsiteInput(raw);
  if (!host) return true;
  return BLOCKED_WEBSITE_HOST_SUFFIXES.some(
    (suffix) => host === suffix || host.endsWith(`.${suffix}`),
  );
}

export function companyWebsiteBlockReason(raw: string): string | null {
  if (!raw.trim()) return "Bitte geben Sie die Website Ihres Unternehmens an.";
  if (isBlockedCompanyWebsite(raw)) {
    return "Das ist keine Unternehmenswebsite. Bitte die öffentliche Website Ihrer Firma eingeben (z. B. firma.de), nicht ChatGPT oder andere Plattform-Links.";
  }
  return null;
}
